import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {IInvestmentDTO} from "../types/IInvestmentListDTO";

interface IInvestmentGalleryModalState {
    investment: IInvestmentDTO | null;
    isInquirySent: boolean;
}

const INITIAL_STATE: IInvestmentGalleryModalState = {
    investment: null,
    isInquirySent: false
};

export const investmentGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentGalleryModal",
    reducers: {
        closeInvestmentGalleryModal: () => INITIAL_STATE,
        openInvestmentGalleryModal: (_state, action: PayloadAction<IInvestmentGalleryModalState>) => action.payload
    }
});

export const {closeInvestmentGalleryModal, openInvestmentGalleryModal} = investmentGalleryModalSlice.actions;
export const selectInvestmentGalleryModal = (state: RootState) => state.investmentGalleryModal;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {IInvestmentDTO} from "../types/IInvestmentListDTO";

interface IInvestmentGalleryModalState {
    investment: IInvestmentDTO | null;
    isInquirySent: boolean;
}

const INITIAL_STATE: IInvestmentGalleryModalState = {
    investment: null,
    isInquirySent: false
};

export const investmentGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentGalleryModal",
    reducers: {
        closeInvestmentGalleryModal: () => INITIAL_STATE,
        openInvestmentGalleryModal: (_state, action: PayloadAction<IInvestmentGalleryModalState>) => action.payload
    }
});

export const {closeInvestmentGalleryModal, openInvestmentGalleryModal} = investmentGalleryModalSlice.actions;
export const selectInvestmentGalleryModal = (state: RootState) => state.investmentGalleryModal;
